import { render, staticRenderFns } from "./reportProductProfitable.vue?vue&type=template&id=007be5b2&scoped=true&"
import script from "./reportProductProfitable.vue?vue&type=script&lang=js&"
export * from "./reportProductProfitable.vue?vue&type=script&lang=js&"
import style0 from "./reportProductProfitable.vue?vue&type=style&index=0&id=007be5b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007be5b2",
  null
  
)

export default component.exports